/*
  Preenche os campos hidden do formulário de contato (#form-contato, ver
  wwwroot/index.html) com a origem de quem chegou no site: parâmetros
  utm_source/utm_medium/utm_campaign/utm_content da URL, a página de entrada
  (landing_page) e o referrer. Assim, quando o formulário é enviado, a
  origem do lead já vai junto — sem precisar perguntar "como você nos
  encontrou?" no próprio formulário.
*/
(function () {
    var form = document.getElementById('form-contato');
    if (!form) return;

    var params = new URLSearchParams(window.location.search);

    function preenche(id, valor) {
        var campo = document.getElementById(id);
        if (campo) campo.value = valor || '';
    }

    preenche('contato-utm-source', params.get('utm_source'));
    preenche('contato-utm-medium', params.get('utm_medium'));
    preenche('contato-utm-campaign', params.get('utm_campaign'));
    preenche('contato-utm-content', params.get('utm_content'));
    preenche('contato-landing-page', window.location.href);
    preenche('contato-referrer', document.referrer);
})();
